<template>
    <v-main class="promoter-profit-list-page">
        <v-app-bar app flat light color="white">
            <AppbarBackIcon />
            <v-toolbar-title class="font-weight-bold">
                <span>收益记录</span>
            </v-toolbar-title>
        </v-app-bar>
        <v-container fluid class="content">
            <div class="section-header">
                <div class="header-row" v-if="promoter_customer_id">
                    <span class="header-label">推广员ID:</span>
                    <span class="header-value">{{ promoter_customer_id }}</span>
                </div>
                <div class="header-row" v-if="payout_order_id">
                    <span class="header-label">提现ID:</span>
                    <span class="header-value">{{ payout_order_id }}</span>
                </div>
            </div>
            <div class="section-profit">
                <div v-if="isEmpty">无收益记录</div>
                <PromoterProfitList :profitList="profitList" />
            </div>
        </v-container>
    </v-main>
</template>
  
<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import PromoterProfitList from '@/components/PromoterProfitList.vue'
import { homeStore } from '@/store/home'
import { promoterProfitStore } from '@/store/promoter/profit'

export default {
    name: 'PromoterProfitListPage',
    components: { AppbarBackIcon, PromoterProfitList },
    data() {
        return {
            isReady: false,
        }
    },
    computed: {
        isEmpty() {
            return this.isReady && this.profitList.length <= 0
        },
        profitList() {
            return promoterProfitStore.list
        },
        params() {
            let qs = this.$route.query
            let params = {
                promoter_customer_id: qs.promoter_customer_id,
                payout_order_id: qs.payout_order_id,
            }
            return params
        },
        promoter_customer_id() {
            return this.params.promoter_customer_id
        },
        payout_order_id() {
            return this.params.payout_order_id
        }
    },
    async mounted() {
        await homeStore.doLoad()
        await promoterProfitStore.doLoad(this.params)
        this.isReady = true
    },
    methods: {},
}
</script>
  
<style lang="less" scoped>
.content {
    padding: 16px;

    .section-header {
        .header-row {
            .header-label {
                margin-right: 8px;
            }

            .header-label,
            .header-value {
                font-weight: bold;
            }
        }
    }

    .section-profit {
        margin-top: 16px;
    }
}
</style>
  